export const EMPLOYEE_BASE_URL: string = process.env.REACT_APP_API_KEY || '';
// export const EMPLOYEE_BASE_URL: string = 'http://178.128.61.122:8081';

export const EMPLOYEE_LOGIN: string = EMPLOYEE_BASE_URL + '/admin/auth/login';
export const EMPLOYEE_REFRESH_TOKEN: string = EMPLOYEE_BASE_URL + '/admin/auth/refreshToken';
export const EMPLOYEE_GET_OFFICER_BY_TOKEN: string = EMPLOYEE_BASE_URL + '/admin/auth/getOfficerByToken';
export const EMPLOYEE_CHANGE_PASSWORD : string = EMPLOYEE_BASE_URL + "/admin/auth/changePassword"
export const EMPLOYEE_CHANGE_DRIVER_PASSWORD : string = EMPLOYEE_BASE_URL + "/admin/auth/change-password-rider"
export const EMPLOYEE_CHANGE_ADMIN_PASSWORD : string = EMPLOYEE_BASE_URL + "/admin/auth/change-password-other-admin";

export const OFFICER_PROFILE_FIND_ONE:string=EMPLOYEE_BASE_URL+"/profile/officer-profile/find-one";